import Icon from 'veui/components/Icon'
import { IconTemplate } from 'dls-icons-vue'

Icon.register('template', IconTemplate)
